<template>
  <div :class="$style['pt-page-title']">
      <div :class="$style['title-search']">
        <div :class="$style['pt-page-title-text']">
          {{title}} <slot name="on-right"/>
        </div>
        <div :class="$style['pt-page-title-search']" >
            <pt-page-search :searchKey="searchKey" v-if="isSearch" :isParams="isParams" :keyName="keyName" :placeholder="placeholder"></pt-page-search>
            <slot/>
        </div>
      </div>
      <div :class="$style['second-eare']">
          <div :class="$style['before-content']">
            <slot name="before-left"/>
          </div>
          <slot name="before-right" :class="$style['title-second-right']"/>
      </div>

  </div>
</template>

<script>
// 调用此组件的时候可直接调用其子组件的“search”方法。同在本组件中调用方法一致
// 组件class前缀
import ptPageSearch from 'cps/base/pt-page-search'

const prefixCls = 'pt-page-title'
export default {
  name: 'pt-page-title',
  props: {
    placeholder: {
      type: String,
      default: '请输入关键字搜索'
    },
    title: {
      type: String,
      default: ''
    },
    isSearch: {
      type: Boolean,
      default: false
    },
    searchKey: {
      type: [String, Number],
      default: ''
    },
    // 搜索条件是否与其他筛选条件共存
    isParams: {
      type: Boolean,
      default: false
    },
    //
    keyName: {
      type: String,
      default: 'searchKey'
    }
  },
  components: {
    ptPageSearch
  },
  watch: {
    searchKey (val) {
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-page-title{
    // display: flex;
    // justify-content: space-between;
    margin-bottom: 25px;
}
.title-search{
    display: flex;
    justify-content: space-between;
}
.pt-page-title-text{
    font-size: 25px;
    line-height: 40px
}
.pt-page-title-search{
    display: flex;

}
.second-eare{
    display: flex;
    padding-top: 25px;
}
.before-content{
    flex: 1;
    :global
    .el-button{
        margin-right: 20px;
    }
}

</style>
